import {
    getOutputRecord,
    setOutputRecordPageSize,
    setColSearchStr,
    setColSort,
    applyOutputRecordFilter,
    setOutputRecordFilter,
    getAttachment,
    getOutputRecordId

} from "../../../../constants/model-reducers/external/recharge/output-record/output-record.settings";
import { httpPost, httpDownload, httpGet } from "../../../../utils/api.utils";
import { DEFAULT_TABLE_RESULT_MODEL } from "../../../../constants/external-constants";
import { convertToFormatLocalDate, convertToFormatTimeZoneDate } from "../../../../utils/helpers.utils";

const defaulstate=()=>(
    {
        outputRecord: DEFAULT_TABLE_RESULT_MODEL,
        outputRecordColSort: "",
        outputRecordIsSortedAsc: true,
        outputRecordFilterData: [],
        outputRecordFilterLoaded: false,
        outputRecordTableFilterList: [],
        outputRecordTableFilterApply: false,
        attachFile:[],
        outputRecordId:{}

    }
)

const initialState=defaulstate();

export const OutputRecordAction = {
     fetchOutputRecord : (pageIndex=0) => async (dispatch, state) => {
        const { Headers, Pagination } = state().outputRecord.outputRecord;
        const { outputRecordColSort, outputRecordIsSortedAsc, outputRecordTableFilterList, outputRecordTableFilterApply } = state().outputRecord;
        var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes,
                },
                Eid: JSON.parse(sessionStorage.getItem("User")).Employee.EnterpriseId,
                UserId: sessionStorage.getItem("UserID"),
                EmployeeId: sessionStorage.getItem("EmployeeID"),
                Headers: {...Headers },
                SortedColumnName: outputRecordColSort,
                IsSortAscending: outputRecordIsSortedAsc,
                TableFilterList: outputRecordTableFilterList,
                ApplyFilter: outputRecordTableFilterApply,
            };

        var result = await httpPost('external/recharge/getOutputRecords',data);
       dispatch({
           type: getOutputRecord,
           payload: result,
           result: Object.keys(result).length > 0 ? result : DEFAULT_TABLE_RESULT_MODEL,
       })

     },

     resizePageSize : (pageSize) => async (dispatch, state)=>{
        dispatch({
            type: setOutputRecordPageSize, 
            payload: parseInt(pageSize) 
        })
     },

    setColSearchStr : (event,key) =>async (dispatch, state)=>{
        const {outputRecord}=state().outputRecord;
        const val=event.target.value;
        const updatedOutputRecord={
            ...outputRecord,
            Headers: {
                ...outputRecord.Headers,
                [key]:{
                    ...outputRecord.Headers[key],
                    searchString: val
                }
            }
        };
        dispatch({
            type: setColSearchStr,
            payload: updatedOutputRecord
        })
    }, 

    setColSort : (isClick, isSortAsc)=> async(dispatch, state)=>{
        const { PageNumber, PageSizes } = state().outputRecord.outputRecord.Pagination;
        const { outputRecordTableFilterList, outputRecordTableFilterApply, outputRecord } = state().outputRecord;
        var data = {
                PageFilter: {
                    PageIndex: PageNumber !== undefined ? PageNumber : 0,
                    PageSize: outputRecord.Pagination.PerPage,
                    PageSizes: PageSizes,
                },
                Eid: JSON.parse(sessionStorage.getItem("User")).Employee.EnterpriseId,
                UserId: sessionStorage.getItem("UserID"),
                EmployeeId: sessionStorage.getItem("EmployeeID"),
                Headers: {...outputRecord.Headers },
                SortedColumnName: isClick,
                IsSortAscending: isSortAsc,
                TableFilterList: outputRecordTableFilterList,
                ApplyFilter: outputRecordTableFilterApply,
            };

        var result = await httpPost('external/recharge/getOutputRecords',data);
       dispatch({
           type: setColSort,
           payload: result,
           outputRecordColSort: isClick,
           outputRecordIsSortedAsc: isSortAsc, 
       })
    },

    applyOutputRecordFilter: (isApply) => (dispatch, state) => {
        const { outputRecordTableFilterList } = state().outputRecord;

        dispatch({
            type: applyOutputRecordFilter,
            applyFilter: isApply,
            filterList: isApply ? outputRecordTableFilterList : [],
        });
    },

    addOutputRecordFilter: (tableFilter) => (dispatch, state) => {
        const { outputRecordTableFilterList } = state().outputRecord;
        var filterList = [...outputRecordTableFilterList, tableFilter];

        dispatch({
            type: setOutputRecordFilter,
            filterList: filterList,
        });
    },

    removeOutputRecordFilter: (removeIndex) => (dispatch, state) => {
        const { outputRecordTableFilterList } = state().outputRecord;
        var filterList = outputRecordTableFilterList.filter((item, index) => index !== removeIndex);

        dispatch({
            type: setOutputRecordFilter,
            filterList: filterList,
        });
    },

    extractOutputRecord : ()=> async (dispatch, state)=>{
        const { Headers } = state().outputRecord.outputRecord;
        const { outputRecordColSort, outputRecordIsSortedAsc, outputRecordTableFilterList, outputRecordTableFilterApply } = state().outputRecord;
 
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\\|?*]/g, '-');

        var filename = `ATEM ${dealName} Output Records Extract – ${formattedTimeZoneDate}`;
 
        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: outputRecordColSort,
            IsSortAscending: outputRecordIsSortedAsc,
            FileName: filename,
            TableFilterList: outputRecordTableFilterList,
            ApplyFilter: outputRecordTableFilterApply,
        };
 
        httpDownload('external/recharge/getExtractOutputRecords', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });

    },
    fetchAttachment: (fileId = 0) => async (dispatch, state) => {
        const { activeDateFormat } = state().adminSetting;
        const result = await httpGet(`external/recharge/getFileAttachment/${fileId}`);
        if (!Array.isArray(result)) {
            console.error("API did not return a valid array for attachments.");
            dispatch({
                type: getAttachment,
                payload: result
            });
            return result;
        }

        const processedResult = result.map(file => {
            
             const dateRegex = new RegExp(
                `((?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\\s\\d{1,2},\\s\\d{4})` +
                `|(\\d{4}-\\d{2}-\\d{2})` +
                `|(\\d{2}\\/\\d{2}\\/\\d{4})`,
                'i'
            );
            
            const match = file.FileName.match(dateRegex);
            if (match && match[0]) {
                const originalDateString = match[0];
                const dateFromFile = new Date(originalDateString);

                if (!isNaN(dateFromFile.getTime())) {
                    const dateFormat = convertToFormatLocalDate(dateFromFile, activeDateFormat.Name);
                    const newFileName = file.FileName.replace(originalDateString, dateFormat);
                    return {
                        ...file,
                        FileName: newFileName,
                    };
                }
            }
            return file;
        });

        dispatch({
            type: getAttachment,
            payload: processedResult
        });
        
        return processedResult;
    },
    fetchOutputRecordById:(recordId)=> async(dispatch, state) => {
         var res = await httpGet(`external/recharge/getOutputRecordsId/${recordId}`);
         if(res) {
            dispatch({
                type:getOutputRecordId,
                payload:res
            })
         }

         return res;
    }

}

export const reducer=(state,action)=>{
     state=state||initialState;
     switch(action.type) {
        case getOutputRecord:
            return{
                ...state,
                outputRecord: action.payload
            }
        case setOutputRecordPageSize: 
            return{
                ...state, 
                outputRecord: {
                    ...state.outputRecord, 
                    Pagination: {
                        ...state.outputRecord.Pagination,
                        PerPage: action.payload
                    }
                }
            }  
        case setColSearchStr:
            return{
                ...state,
                outputRecord: action.payload
             }  
        case setColSort:
            return {
                ...state,
                outputRecord: action.payload,
                outputRecordColSort: action.outputRecordColSort,
                outputRecordIsSortedAsc: action.outputRecordIsSortedAsc,
            }; 
        case applyOutputRecordFilter:
            return {
                ...state,
                outputRecordTableFilterApply: action.applyFilter,
                outputRecordTableFilterList: action.filterList,
            };
        case setOutputRecordFilter:
            return {
                ...state,
                outputRecordTableFilterList: action.filterList,
            };
        case getAttachment:
            return {
                ...state,
                attachFile:action.payload
            }
        case getOutputRecordId:
            return {
                ...state,
                outputRecordId:action.payload
             }

        default: 
            return state;
     }

}